
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dining/restaurant-bar/[marsha]-[hotelName]/[outletId]-[outletName]",
      function () {
        return require("private-next-pages/dining/restaurant-bar/[marsha]-[hotelName]/[outletId]-[outletName].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dining/restaurant-bar/[marsha]-[hotelName]/[outletId]-[outletName]"])
      });
    }
  